import React from 'react'
import ShopHeader from './ShopHeader'

const Payment = () => {
  return (
    <div>
      <ShopHeader />
      <div className='row mt-5'>
        <div>
          <h1 className='h1t'>ENTER PAYMENT DETAILS</h1>
        </div>
        <div>
          <input className='inputt' type='text' placeholder="Card Number"/>
          <input className='inputt' type='text' placeholder="UPI Id" />
          <button className='btn btn-primary butnon'>Pay</button>
        </div>
      </div>
    </div>
  )
}

export default Payment